<template>
  <div
    class="father_box"
    v-loading="isnowreasver"
    element-loading-text="试卷正在组成中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="main_form">
      <div>
        <el-collapse v-model="activeKcSetting">
          <el-collapse-item title="考场设置" name="1">
            <div class="son_input">
              <div class="bacle_input">
                <h5>考试名称：</h5>
                <el-input
                  v-model.trim="$parent.newExamInfo.ExamName"
                  placeholder="请输入内容"
                  maxlength="30"
                  show-word-limit
                  class="standard_input"
                ></el-input>
              </div>
              <div class="bacle_input">
                <h5>考试时间：</h5>
                <div class="block">
                  <el-date-picker
                    v-model="value1"
                    @change="timechange"
                    value-format="yyyy-MM-dd HH:mm"
                    class="standard_input"
                    type="datetimerange"
                    :picker-options="
                      $route.query.trainId ? pickerOptions : pickerOptions0
                    "
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @focus="obtainTime"
                    :default-time="[vehicleTime, '23:59:59']"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="bacle_input">
                <h5>答题时长：</h5>
                <el-input
                  v-model.trim="inputtesttime"
                  maxlength="3"
                  placeholder="不应低于60分钟"
                  class="standard_input"
                  @blur="checktesttime"
                ></el-input>
                <p>分钟</p>
              </div>
              <div class="special_input">
                <h5>注意事项：</h5>
                <div class="special_box">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model.trim="attention"
                    class="text_field"
                    resize="none"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>

    <!-- 考生设置 -->
    <el-card class="main_form">
      <div>
        <el-collapse v-model="activeKsSetting">
          <el-collapse-item title="考生设置" name="1">
            <div class="title_box">
              <!-- 操作按钮部分 -->
              <div class="operation_box">
                <el-button @click="addExaminee" type="primary">
                  <i class="iconfont icon-xinzeng"></i>添加</el-button
                >
                <el-button @click="batchDelect" type="danger">
                  <i class="iconfont icon-zu11540"></i>批量删除
                </el-button>
              </div>
              <!-- 账号搜索 -->
              <div class="search_view">
                <div class="search">
                  <el-input
                    v-model="inputSearch"
                    placeholder="根据考生姓名或账号搜索"
                    type="text"
                  ></el-input>
                  <el-button @click="handleSerachStudent">
                    <i class="iconfont icon-sousuo"></i>
                  </el-button>
                </div>
                <el-button
                  @click="resetQuery"
                  icon="el-icon-refresh"
                  class="searchbtn"
                  >重置</el-button
                >
              </div>
            </div>
            <div class="examinee_form">
              <p>
                已选{{ examStudentList.length }}人，科室{{ this.unique() }}个
              </p>
              <!-- 表格内容 -->
              <sys-box-table
                ref="sysBoxTable"
                :tableList="examStudentListTable"
                rowKey="userID"
                :showIndex="true"
                operationWidth="200px"
                tableHeight="650px"
                :columList="formColumns"
                @handleSelectionChange="handleSelectionChange"
                v-loading="tableLoading"
              >
                <template #slotButton="slotProps">
                  <el-button
                    type="text"
                    @click.stop="delectstudent(slotProps)"
                    style="font-size: '18px'"
                    >删除</el-button
                  >
                </template>
              </sys-box-table>
            </div>
            <!-- 按钮 -->
            <div class="baic_content">
              <div class="operation">
                <el-button class="succ_btn" @click="nextPage(0)"
                  >上一步</el-button
                >
                <el-button
                  type="success"
                  class="submit_btn"
                  @click="submitExam"
                  :loading="isLoading"
                  >发布试卷</el-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>
    <!-- 子组件弹窗 -->
    <FourPup ref="popup" />
    <!-- 弹框 -->
    <sys-dialog
      :title="messageDialog.title"
      :width="messageDialog.width"
      :height="messageDialog.height"
      :visible="messageDialog.visible"
      @onConfirm="messageConfirm"
      @onClose="messageClose"
    >
      <div slot="content" class="message-text">
        <i class="iconfont icon-tishi1"></i>
        <p style="">是否确定移除考生【{{ selectedName }}】参加本次考试吗！</p>
      </div>
    </sys-dialog>

    <!-- 弹框 -->
    <sys-dialog
      :title="submitDialog.title"
      :width="submitDialog.width"
      :height="submitDialog.height"
      :visible="submitDialog.visible"
      @onConfirm="submitConfirm"
      @onClose="submitClose"
    >
      <div slot="content" class="message-text">
        <i class="iconfont icon-tishi1"></i>
        <p style="">确定发布本次考试吗?</p>
      </div>
    </sys-dialog>
  </div>
</template>

<script>
import $monitor from "@/api/monitor.js";
import FourPup from "./FourPup.vue"; //添加考生的弹窗
import SysBoxTable from "@/components/system/SysBoxTable";
import SysDialog from "@/components/system/SysDialog";
import training from "@/api/trainingApi";
import { ManagerunLock } from "@/api/index.js";
export default {
  name: "Pagefour",
  props: ["nextPage"],
  data() {
    return {
      batchDialog: false,
      submitDialog: {
        title: "温馨提示",
        width: 440,
        height: 72,
        visible: false,
      },
      messageDialog: {
        title: "温馨提示",
        width: 440,
        height: 72,
        visible: false,
      },
      formColumns: [
        {
          prop: "RealName",
          lable: "考生姓名",
          width: "",
          align: "center",
        },
        {
          prop: "UserName",
          lable: "考生账号",
          width: "",
          align: "center",
        },
        {
          prop: "DepartmentName",
          lable: "科室名称",
          width: "",
          align: "center",
        },
        {
          prop: "PTitle",
          lable: "职称",
          width: "",
          align: "center",
        },
        {
          prop: "Position",
          lable: "职位",
          width: "",
          align: "center",
        },
        {
          prop: "Birthday",
          lable: "出生日期",
          width: "",
          align: "center",
          type: "date",
        },
        {
          prop: "userExamType",
          lable: "考试状态",
          width: "",
          align: "center",
        },
        {
          prop: "JobDate",
          lable: "工作年限",
          width: "",
          align: "center",
        },
      ],
      selectUserIds: [],
      selectedUserName: [],
      selectedName: "", //选中的人
      selectedId: "", //选中的用户id
      pickerOptions: {
        //禁用当前前面的时间日期
        disabledDate(time) {
          // 培训的限制
          const row = JSON.parse(localStorage.getItem("examRowTime"));
          if (row.begainTime) {
            const begainTime = row.begainTime;
            const endTime = row.endTime;
            return (
              time.getTime() < new Date(begainTime).getTime() ||
              time.getTime() > new Date(endTime).getTime()
            );
          }
        },
      },
      pickerOptions0: {
        //禁用当前前面的时间日期
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      pageParms: {
        // 当前页
        currentPage: 1,
        pageSize: 999999,
        pagesizesArr: [5, 10, 20, 50, 100],
        // 总数量
        total: 100,
      },
      activeKcSetting: ["1"],
      activeKsSetting: ["1"],
      value1: [], //开始和结束的时间
      StartDatestr: "", //开始的时间
      EndDate: "", //
      vehicleTime: "", // 默认时分
      attention:
        '1、请核对自己的编号(准考证号)，姓名等基本资料是否属实，如有错误请举手向监考老师示意；\n2、请注意答题时间，当倒计时时间为0，系统自动收卷；\n3、如遇电脑问题、网络问题、或电脑死机等情况，请举手向监考老师示意；\n4、请注意考场环境，保持安静，请勿相互交头接耳；\n5、请在提交试卷后看到"恭喜，您的考试成绩如下"或"考试结束，您的成绩提交成功"后方可离开考场。', // 注意事项
      inputtesttime: "120", //答题时间
      isnowreasver: false, //正在发布试卷中，全局遮罩
      isLoading: false, //按钮加载防抖。
      tableLoading: false,
      examStudentList: [], //考生列表
      examStudentListTable: [], //考生列表展示列表上
      inputSearch: "",
      textarea: "",
    };
  },
  components: {
    FourPup,
    SysBoxTable,
    SysDialog,
  },
  created() {
    // this.value1.push(this.$moment(this.$parent.newExamInfo.BeginTime).format("YYYY-MM-DD HH:mm"));
    // this.value1.push(this.$moment(this.$parent.newExamInfo.EndTime).format("YYYY-MM-DD HH:mm"));
    this.initSerachStudent();
  },
  methods: {
    submitConfirm: function () {
      this.submitDialog.visible = false;
      this.isnowreasver = true;
      let userIds = [];
      this.examStudentList.forEach((user) => {
        userIds.push(user.userID);
      });
      let parms = {};
      parms.examID = this.$parent.newExamInfo.ExamID;
      parms = this.UtilFun(parms);
      parms.NewExamName = this.$parent.newExamInfo.ExamName;
      parms.NewStartTime = this.value1[0];
      parms.NewEndTime = this.value1[1];
      parms.SpendTime = this.inputtesttime;
      parms.MakeUpUserId = userIds.toString();
      $monitor
        .makeUpExam(parms)
        .then((res) => {
          let result = res.data;
          if (result.Status === 200) {
            setTimeout(() => {
              this.isnowreasver = false;
              if (this.$route.query.trainId) {
                this.$alert(
                  "补考学分默认为0，请及时前往任务配置更改学分。",
                  "温馨提示",
                  {
                    confirmButtonText: "确定",
                    callback: async (action) => {
                      // 此处把默认的考场关闭开启一下
                      const obj = {
                        examID: res.data.Data[0][0].newExamID,
                        hid: this.$store.state.hid,
                      };
                      const { data } = await ManagerunLock(obj);
                      this.trainingReturn(res.data.Data[0][0].newExamID);
                    },
                  }
                );
              } else {
                this.trainingReturn(res.data.Data[0][0].newExamID);
                this.$message.success("试卷发布成功");
              }
            }, 1000);
          } else {
            this.$message.error("发布试卷失败！");
            this.isnowreasver = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async trainingReturn(id) {
      if (this.$route.query.trainId) {
        // 培训的去向
        const obj = {
          trainId: this.$route.query.trainId,
          type: this.$route.query.examType,
          typeId: id,
        };
        const { data } = await training.addTrainByID(obj);
        if (data.Status == 200) {
          this.$router.push({
            path: this.$route.query.toUrl,
            query: {
              trainId: this.$route.query.trainId,
              toUrl: this.$route.query.toUrl,
              state: "xxqk",
            },
          });
        } else {
          this.$router.push("/Papers");
        }
      } else {
        this.$router.push("/Papers");
      }
    },
    submitClose: function () {
      this.submitDialog.visible = false;
    },
    submitExam: function () {
      if (this.value1 == "") {
        this.$message.warning("请先选择考试时间！");
        return;
      }
      this.submitDialog.visible = true;
      console.log("======", this.examStudentList);
    },
    makeUpExamUserList: function (parms) {
      this.tableLoading = true;
      parms.examID = this.$parent.newExamInfo.ExamID;
      parms = this.UtilFun(parms);
      parms.PageIndex = this.pageParms.currentPage - 1;
      parms.PageShow = this.pageParms.pageSize;
      $monitor
        .makeUpExamUserList(parms)
        .then((res) => {
          let result = res.data;
          if (result.Status === 200) {
            this.examStudentList = result.Data.data[0];
            this.examStudentListTable = this.$objCopy.listAllCopy(
              this.examStudentList
            );
          } else {
            this.$message.error("获取考生信息失败！");
          }
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 封装方法
    UtilFun: function (paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    initSerachStudent: function () {
      let parms = {};
      parms.userExamType = "3";
      this.makeUpExamUserList(parms);
    },
    //查询搜索
    handleSerachStudent: function () {
      let studentArrayList = [];
      let searchString = this.inputSearch; // input的数据
      if (!searchString) {
        this.examStudentListTable = this.$objCopy.listAllCopy(
          this.examStudentList
        );
      } else {
        this.examStudentList.forEach((item) => {
          searchString = searchString.trim();
          if (
            item.RealName.indexOf(searchString) != -1 ||
            item.UserName.indexOf(searchString) != -1
          ) {
            studentArrayList.push(item);
          }
        });
        if (studentArrayList.length > 0) {
          this.examStudentListTable = studentArrayList;
        } else {
          this.$message.warning(`未找到包含“${this.inputSearch}”信息的考生!`);
          return;
        }
      }
    },
    checktesttime: function () {
      let reg = /^[0-9]*$/;
      if (!reg.test(this.inputtesttime)) {
        this.$message.error("请输入纯数字答题时长");
        this.inputtesttime = "";
        return;
      }
    },
    handleSelectionChange: function (data) {
      this.selectUserIds = [];
      this.selectedUserName = [];
      data.forEach((user) => {
        this.selectUserIds.push(user.userID);
        this.selectedUserName.push(user.RealName);
      });
    },
    timechange: function () {
      let nowtime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm");
      let nowdifftime = this.$moment(nowtime).diff(this.value1[0], "minutes");
      if (nowdifftime > 0) {
        this.$message({
          showClose: true,
          message: `考试开始日期时间应大于当前日期时间(${nowtime})`,
          type: "warning",
        });
        return;
      }
      this.StartDatestr = this.value1[0];
      this.EndDate = this.value1[1];
    },
    // 点击获取当前默认时间
    obtainTime: function () {
      let time = new Date(); // 当前时间
      let defaultendtime = new Date(time.getTime() + 1000 * 60 * 30); //开始时间往后延长30分钟。
      this.vehicleTime = this.$moment(defaultendtime).format("HH:mm:ss");
    },
    // 重置
    resetQuery: function () {
      this.inputSearch = "";
      this.handleSerachStudent();
    },
    messageClose: function () {
      this.messageDialog.visible = false;
    },
    messageConfirm: function () {
      if (this.batchDialog) {
        let userIDs = this.selectUserIds.toString();
        //过滤列表中展示的数据
        let fileterTableList = this.examStudentListTable.filter((item) => {
          return userIDs.indexOf(item.userID) == -1;
        });
        //过滤表单中原有的数据
        let fileterList = this.examStudentList.filter((item) => {
          return userIDs.indexOf(item.userID) == -1;
        });
        this.examStudentList = fileterList;
        this.examStudentListTable = fileterTableList;
        this.$refs.sysBoxTable.handleClearSelection();
      } else {
        let userID = this.selectedId;
        //过滤列表中展示的数据
        let fileterTableList = this.examStudentListTable.filter((item) => {
          return item.userID !== userID;
        });
        //过滤表单中原有的数据
        let fileterList = this.examStudentList.filter((item) => {
          return item.userID !== userID;
        });
        this.examStudentList = fileterList;
        this.examStudentListTable = fileterTableList;
        this.$refs.sysBoxTable.handleClearSelection();
      }
      this.messageDialog.visible = false;
    },
    delectstudent: function (row) {
      this.batchDialog = false;
      this.selectedName = row.rowData.RealName;
      this.selectedId = row.rowData.userID;
      this.messageDialog.visible = true;
    },
    batchDelect: function () {
      if (this.selectUserIds.length == 0) {
        this.$message.warning("请先勾选考生！");
        this.batchDialog = false;
      } else {
        this.selectedName = this.selectedUserName.toString();
        this.batchDialog = true;
        this.messageDialog.visible = true;
      }
    },
    addExaminee: function () {
      this.$refs.popup.getExamStudentList();
      this.$refs.popup.messageDialog.visible = true;
    },
    // 去重
    unique: function () {
      let departArr = this.examStudentList.map((item) => {
        return item.DepartmentName;
      });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },

    // 显示条数
    handleSizeChange: function (val) {
      this.pageParms.currentPage = 1;
      this.pageParms.pageSize = val;
      // this.getExamStudentList();
      console.log(`每页 ${val} 条`);
    },
    // 分页
    handleCurrentChange: function (val) {
      console.log(`当前页: ${val}`);
      this.pageParms.currentPage = val;
      // this.getExamStudentList();
    },
  },
};
</script>

<style lang="scss" scoped>
.father_box {
  margin-top: 24px;
}
.baic_content {
  background-color: white;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;

  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-collapse-item__header {
  height: 60px;
  line-height: 60px !important;
  background: #d8edff;
  border-radius: 10px 10px 0px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 19px;
  color: #333333;
  padding: 0px 24px;
}
.main_form {
  border-radius: 13px 13px 0px 0px;
  margin-bottom: 24px;
  ::v-deep .el-collapse-item__arrow {
    font-weight: bolder;
  }
  .son_input {
    // height: 500px;
    .bacle_input {
      align-items: center;
      .standard_input {
        width: 825px;
        height: 40px;
        display: flex;
        align-items: center;
      }
      .text_field {
        width: 673px;
        height: 126px;
      }
      margin-top: 24px;
      padding-right: 40px;
      display: flex;
      p {
        margin-left: 20px;
      }
      h5 {
        min-width: 160px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        text-align: left;
        line-height: 40px;
        padding-left: 20px;
        margin-right: 10px;
        &::before {
          content: "*";
          width: 20px;
          display: inline-block;
          color: #ff0000;
        }
      }
      .icont_pop {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 34px;
          top: 0px;
          color: #d9d9d9;
          // transform: scale(0.6);
          font-size: 20px;
          color: #d8edff;
        }
      }
      .icont_hover {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 6px;
          top: 0px;
          color: #d9d9d9;
          // transform: scale(0.6);
          font-size: 20px;
          color: #d8edff;
        }
      }
    }
  }
}
.special_input {
  display: flex;
  margin-top: 24px;
  .special_box {
    width: 673px;
    height: 126px;
    ::v-deep .el-textarea__inner {
      height: 120px;
    }
  }
  h5 {
    min-width: 160px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
}
.title_box {
  display: flex;
  justify-content: space-between;
  margin: 24px 16px 24px 24px;
  .operation_box {
    display: flex;
    height: 40px;
    opacity: 1;
    border-radius: 4px;
    ::v-deep .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 24px;
      color: #ffffff;
      letter-spacing: 1px;
      span > i {
        font-size: 14px !important;
        margin-right: 5px;
      }
    }
    .el-button:nth-child(1) {
      background: #1890ff;
      width: 121px;
    }
    .el-button:nth-child(2) {
      background: #e54d4d;
      width: 121px;
    }
  }
  .search_view {
    display: flex;
    height: 40px;
    .search {
      display: flex;
      width: 300px;
      height: 40px;
      .el-button {
        width: 40px;
        height: 40px;
        background: #1890ff;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #1890ff !important;
        border-radius: 0px 4px 4px 0px !important;
        i {
          display: inline-block;
        }
      }
      ::v-deep .el-input__inner {
        border-radius: 4px 0px 0px 4px !important;
      }
    }
  }
  .searchbtn {
    margin-left: 14px;
    margin-right: 12px;
  }
}
// 表单
.examinee_form {
  padding: 0 24px;
  p {
    padding: 10px 24px;
    height: 42px;
    background: #eef7ff;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    font-weight: 400;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;

  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  ::v-deep .el-pagination__jump {
    &::before {
      content: "10条/页";
      width: 82px;
      border: 1px solid #d9d9d9;
      height: 28px;
      border-radius: 2px;
      text-align: center;
      display: inline-block;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}

.message-text {
  display: flex;
  i {
    font-size: 16px;
    color: #ffc664;
    margin-right: 10px;
    transform: translateY(4px);
  }
  p {
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    opacity: 1;
  }
}
</style>
